import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { connect } from "react-redux";
import 'file-downloader';
import mime from 'mime-types';
import filesize from 'filesize';
import defaultProjectView from '../../assets/default-project.jpg';
import _ from 'lodash';
import {
  getFile,
  clearFileDetails,
  getFilesByProjectIds
} from '../../redux/files/actions';
import {
  getProject,
  getUserProjects
} from '../../redux/projects/actions';
import {
  getIssuesListByProject,
  getIssuesByProjectId,
  ISSUE_STATE_CLOSED,
  ISSUE_STATE_OPENED,
  ISSUE_STATE_RESOLVED
} from '../../redux/issues/actions';
import * as authSelectors from '../../redux/auth/selectors';
import * as fileSelectors from '../../redux/files/selectors';
import * as projectSelectors from '../../redux/projects/selectors';
import * as issueSelectors from '../../redux/issues/selectors';
import { getCdnFilePath, getFileMetaData, getFilePath, getFilePreviewUrlFullSize } from '../../services/FileStackService';
import moment from 'moment';
import { categoriesOriginal } from '../../fixtures/categories';
import ActivityIndicator from 'react-activity-indicator';
import bottomTearImage from '../../assets/bottom-tear.svg';
import './FileDetails.css';
import {google as config} from '../../config';
import {isIE} from '../../utils/navigator';

const mapStateToProps = (state) => ({
  userId: authSelectors.getUserId(state),
  filesList: fileSelectors.filesList(state),
  details: fileSelectors.fileDetails(state),
  project: projectSelectors.projectDetails(state),
  projectsList: projectSelectors.projectsList(state),
  projectIssues: issueSelectors.issuesList(state),
  issuesById: issueSelectors.issuesByIds(state)
});

const mapDispatchToProps = {
  getFile,
  getProject,
  getIssuesListByProject,
  getIssuesByProjectId,
  clearFileDetails,
  getFilesByProjectIds,
  getUserProjects
};

function getIssueStateText(state) {
  switch (state) {
    case ISSUE_STATE_OPENED:
      return 'Open';
    case ISSUE_STATE_RESOLVED:
      return 'Resolved';
    case ISSUE_STATE_CLOSED:
      return 'Closed';
    default:
      return 'Unknown';
  }
}

class FileDetailsScreen extends Component {

  state = {
    showInfo: true,
    imageError: false,
    imageLoaded: false,
    metaData: false,
    metaDataIsFetching: false,
    sortedList: false
  };

  componentWillMount() {
    const { projectId, fileId } = this.props.match.params;
    if (this.props.details.id !== fileId) {
      this.props.clearFileDetails();
    }
    this.props.getFile(projectId, fileId);
    this.props.getProject(projectId);
    this.props.getIssuesByProjectId(projectId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps === this.props) return;

    const { projectsList, filesList } = nextProps;

    if (filesList && !this.state.sortedList) {
      this.setState({
        sortedList: _.sortBy(filesList, function (file) {
          return moment(file.createdAt);
        })
      });
    }

    if (nextProps.details && nextProps.details.issues) {
      let needUpdate = false;
      nextProps.details.issues.forEach((issueID) => {
        if (typeof nextProps.projectIssues[issueID] === 'undefined') {
          needUpdate = true;
        }
      });
      if (needUpdate) {
        this.props.getIssuesListByProject(this.props.match.params.projectId, nextProps.details.issues);
      }
      if (!this.state.metaData) {
        this.setState({
          metaDataIsFetching: true
        });
        if (!this.state.metaDataIsFetching) {
          getFileMetaData(nextProps.details.filestackId)
            .then((metaData) => {
              this.setState({
                metaData,
                metaDataIsFetching: false
              })
            })
        }
      }
    }

    const projectIDs = Object.keys(projectsList);

    if (!projectIDs.length && nextProps.userId) {
      this.props.getUserProjects(nextProps.userId)
    }

    if (projectIDs.length && Object.keys(filesList).length === 0) {
      this.props.getFilesByProjectIds(projectIDs);
    }
  }

  handleSwitchToNext = (next) => {
    this.props.history.push(`/details/${next.projectId}/${next.id}`);
    this.props.clearFileDetails();

    this.props.getFile(next.projectId, next.id);
    this.props.getProject(next.projectId);
    this.props.getIssuesByProjectId(next.projectId);
  };

  handleSwitchToPrevious = (prev) => {
    this.props.history.push(`/details/${prev.projectId}/${prev.id}`);
    this.props.clearFileDetails();

    this.props.getFile(prev.projectId, prev.id);
    this.props.getProject(prev.projectId);
    this.props.getIssuesByProjectId(prev.projectId);
  };

  handleShowInfoClick = () => {
    this.setState({
      showInfo: !this.state.showInfo
    });
  };

  handleDownloadDocument = (fileStackUrl, downloadName) => {
    if (isIE()) {
      window.open(fileStackUrl, '_blank');
      return;
    }

    window.downloader.get(fileStackUrl, downloadName);
  };
  
  renderDetailsRow(data) {
    return (
      <Row className="info-view-details-item">
        <Col xs={1} className="icon">
          {data.icon && <span className={`fa fa-${data.icon}`} />}
        </Col>
        <Col xs={10}>
          <div className="title">{data.label}:</div>
          <div className="description">{data.value}</div>
        </Col>
      </Row>
    );
  }

  renderFileDetails() {
    const { details } = this.props;
    const rows = [];

    if (typeof details.name !== 'undefined' && details.name.length > 0) {
      rows.push({
        icon: 'file-o',
        label: 'Filename',
        value: details.name
      });
    }

    if (details.owner && details.owner.displayName) {
      rows.push({
        icon: 'user',
        label: 'Uploaded by',
        value: details.owner.displayName
      });
    }

    if (details.createdAt) {
      rows.push({
        icon: 'calendar-plus-o',
        label: 'Upload date',
        value: moment(details.createdAt).format('dddd, MMM D, YYYY, h:mm a')
      });
    }
    
    if (details.metadata && details.metadata.width > 0 && details.metadata.height > 0) {
      rows.push({
        icon: 'expand',
        label: 'Size',
        value: details.metadata.width + ' × ' + details.metadata.height
      });
    }

    if (details.size > 0) {
      rows.push({
        icon: 'cloud',
        label: 'File size',
        value: filesize(details.size)
      });
    }

    if (details.address) {
      rows.push({
        icon: 'location-arrow',
        label: 'Address',
        value: this._prepareAddressRender(details.address)
      });
    }

    if (details.length === 0) {
      return null;
    }
    
    return (
      <div className="file-details">
        <Row>
          <Col xs={12}>
            <h3>Details</h3>
          </Col>
        </Row>
        <Row className="info-view-details">
          <Col xs={12}>
            {rows.map((data) => this.renderDetailsRow(data))}
          </Col>
        </Row>
      </div>
    );
  }

  _prepareAddressRender = (address) => {

    return `${address.country}, ${address.city}, ${address.route} ${address.street_number}`;
  };
  
  renderIssueDetails(issue, renderDivider = false) {
    if (!issue) {
      return null;
    }


    const rows = [
      {
        icon: 'hashtag',
        label: issue.isIssue ? 'Issue number' : 'Message number',
        value: issue.issueNumber
      }
    ];
    
    if (issue.owner && issue.owner.displayName) {
      rows.push({
        icon: 'user',
        label: 'Created by',
        value: issue.owner.displayName
      });
    }

    if (issue.createdAt) {
      rows.push({
        icon: 'calendar-plus-o',
        label: 'Create date',
        value: moment(issue.createdAt).format('dddd, MMM D, YYYY')
      });
    }

    if (issue.assignTo && issue.assignTo.displayName) {
      rows.push({
        icon: 'user-plus',
        label: 'Assigned to',
        value: issue.assignTo.displayName
      });
    }
    
    if (issue.issueState) {
      rows.push({
        icon: 'line-chart',
        label: 'Issue status',
        value: getIssueStateText(issue.issueState)
      });
    }
    
    if (issue.dueDate) {
      rows.push({
        icon: 'calendar-times-o',
        label: 'Due date',
        value: moment(issue.dueDate).format('dddd, MMM D, YYYY')
      });
    }
    
    if (issue.tagged && Object.keys(issue.tagged).length > 0) {
      rows.push({
        icon: 'user-plus',
        label: 'Shared with',
        value: this.renderSharedWith(issue.tagged)
      });
    }

    if (issue.categories && issue.categories.length > 0) {
      rows.push({
        icon: 'list-ul',
        label: 'Categories',
        value: this.renderCategories(issue.categories)
      });
    }
    
    if (typeof issue.title !== 'undefined' && issue.title.length > 0) {
      rows.push({
        icon: 'file-text-o',
        label: 'Description',
        value: issue.title
      });
    }

    if (issue.location) {
      rows.push({
        icon: 'map-marker',
        label: 'Location',
        value: this._prepareLocationRender(issue)
      });
    }
    
    return (
      <Row className="info-view-details">
        <Col xs={12}>
          {rows.map((data) => this.renderDetailsRow(data))}
          {renderDivider && <img src={bottomTearImage} alt="" />}
        </Col>
      </Row>
    )
  }

  _prepareLocationRender = (issue) => {
    const {location} = issue;
    let renderString = '';

    if (location.projectSettings.main.key === 'residential' && location.projectSettings.sub.key === 'single-family' || location.projectSettings.main.key === 'commercial' && location.projectSettings.sub.key === 'single-unit') {
      renderString = '';
    }
    if (location.projectSettings.main.key === 'residential' && location.projectSettings.sub.key === 'multiple-houses' || location.projectSettings.main.key === 'commercial' && location.projectSettings.sub.key === 'public-area') {
      renderString = `${location.unit.name}. `;
    }
    if (location.projectSettings.main.key === 'residential' && location.projectSettings.sub.key === 'building-complex' || location.projectSettings.main.key === 'commercial' && location.projectSettings.sub.key === 'building-complex' || location.projectSettings.main.key === 'general' && location.projectSettings.sub.key === 'general') {
      renderString = location.building && location.building.name ? `${location.building.name}` : '';
      renderString += location.floor && location.floor.name ? `, ${location.floor.name}` : '';
      renderString += location.unit && location.unit.name ? `, ${location.unit.name}. ` : '';
    }

    let roomArray = [];
    let roomString = '';

    if (location.room) {
      Object.values(location.room).map((room) => {
        roomArray.push(room.name);
      });
      roomString = roomArray.join(', ');
    }

    return renderString + roomString;
  };

  renderLinkedIssues() {
    const { projectIssues, details } = this.props;
    const issuesCount = details.issues ? details.issues.length : 0;
    
    if (!issuesCount) {
      return null;
    }
    
    return (
      <div className="linked-issues">
        <Row>
          <Col xs={12}>
            <h3>Linked Issues</h3>
          </Col>
        </Row>
        {details.issues.map((issueId, idx) => this.renderIssueDetails(projectIssues[issueId], idx < issuesCount - 1))}
      </div>
    );
  }

  renderStaticMap(){
    const { details } = this.props;

    if(!details.address){

      return null;
    }

    const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${details.address.geo.lat}, ${details.address.geo.lng}&zoom=16&size=400x400&markers=red|${details.address.geo.lat}, ${details.address.geo.lng}&key=${config.apiKey}`;
    const mapUrl = `http://maps.google.com/maps?z=10&t=m&q=loc:${details.address.geo.lat}+${details.address.geo.lng}`;

    return (
      <div className="linked-issues">
        <Row>
          <Col xs={12}>
            <h3>Map</h3>

          </Col>
        </Row>
        <a href={mapUrl} target="_blank">
          <img src={staticMapUrl} />
          <div style={{paddingBottom: '10px'}}>Click to see on map</div>
        </a>
      </div>
    );
  }

  renderSharedWith = (sharedWith) => {
    return Object.keys(sharedWith).map((userId, index) => {
      return (<div key={index}>{sharedWith[userId].displayName}</div>);
    })
  };

  renderCategories = (categories) => {
    return categories.map((categoryId, index) => {
      return (<span key={index}>{categoriesOriginal[categoryId].title}{index < categories.length - 1 ? ', ' : ''}</span>);
    })
  };

  _handleImageError = () => {
    this.setState({
      imageError: true
    })
  };

  _handleImageLoad = () => {
    this.setState({
      imageLoaded: true
    })
  };

  render() {
    const { details, projectIssues } = this.props;
    console.log('TCL: FileDetailsScreen -> render -> details', details);
    const { sortedList } = this.state;
    let downloadName = '';
    if (details && details.issues && typeof projectIssues[details.issues[0]] !== 'undefined') {
      downloadName = details.name === ''
        ? 'pulser_' + (projectIssues[details.issues[0]].isIssue ? 'issue' : 'message') + '_' + projectIssues[details.issues[0]].issueNumber + '.' + mime.extension(this.state.metaData.mimetype)
        : details.name;
    }

    let currentPosition,
      nextItem,
      previousItem;

    if (sortedList) {
      currentPosition = parseInt(_.findKey(sortedList, { id: details.id }));
      nextItem = typeof sortedList[currentPosition + 1] === 'undefined'
        ? sortedList[0]
        : sortedList[currentPosition + 1];
      previousItem = typeof sortedList[currentPosition - 1] === 'undefined'
        ? sortedList[sortedList.length - 1]
        : sortedList[currentPosition - 1];
    }

    let projectImage;
    if (!this.props.project.images) {
      projectImage = <img src={defaultProjectView} alt="" />;
    } else if (this.props.project.images.main) {
      projectImage = <img src={this.props.project.images.main} alt="" />;
    }

    return (
      <Grid fluid>
        <Row className={`background-view info-${this.state.showInfo ? 'opened' : 'closed'}`}>
          <Col xs={this.state.showInfo ? 9 : 12}>
            <div className="right-side-buttons">
              {details.name === '' && this.state.metaData && this.state.metaData.mimetype &&
              <button
                className="control-button"
                onClick={() => {
                  this.handleDownloadDocument(`${getFilePath(details.filestackId)}?dl=true`, downloadName)
                }}
              >
                <i className="fa fa-download" />
              </button>
              }
              {details.name !== '' &&
              <button
                className="control-button"
                onClick={() => {
                  this.handleDownloadDocument(`${getFilePath(details.filestackId)}?dl=true`, details.name)
                }}
              >
                <i className="fa fa-download" />
              </button>
              }
              <button className="control-button" onClick={this.handleShowInfoClick}>
                <i className="fa fa-info-circle" />
              </button>
            </div>
            {Object.keys(details).length > 0 &&
            <Row center="xs" middle="xs" className="image-wrapper">
              <Col xs={2} sm={1} md={1} lg={1} className="previous-wrapper">
                <Row middle="xs" center="xs">
                  {previousItem &&
                  <button onClick={() => {
                    this.handleSwitchToPrevious(previousItem)
                  }}>
                    <Col xs={12}>
                      <svg width="36px" height="36px" className="pn-icon" viewBox="0 0 24 24">
                        <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" />
                      </svg>
                    </Col>
                  </button>
                  }
                </Row>
              </Col>
              <Col xs={8} sm={10} md={10} lg={10}>
                {details.type === 'document' &&
                <a href={details.uri}>
                  <img
                    onLoad={this._handleImageLoad}
                    onError={this._handleImageError}
                    src={getFilePreviewUrlFullSize(details.filestackId)}
                    className={`${!this.state.imageLoaded || this.state.imageError ? 'hidden' : ''}`}
                    alt=""
                  />
                </a>
                }
                {details.type === 'photo' &&
                <img
                  onLoad={this._handleImageLoad}
                  src={getCdnFilePath(details.filestackId)}
                  className={`${!this.state.imageLoaded ? 'hidden' : ''}`}
                  alt=""
                />
                }
                {!this.state.imageLoaded && !this.state.imageError &&
                <Row center="xs" middle="xs" className="activity-wrapper">
                  <Col xs={12}>
                    <ActivityIndicator
                      number={5}
                      diameter={40}
                      duration={100}
                      activeColor="#CECECE"
                      borderWidth={0}
                      borderRadius="50%"
                    />
                  </Col>
                </Row>
                }
              </Col>
              <Col xs={2} sm={1} md={1} lg={1} className="next-wrapper">
                <Row middle="xs" center="xs">
                  {nextItem &&
                  <button onClick={() => {
                    this.handleSwitchToNext(nextItem)
                  }}>
                    <Col xs={12}>
                      <svg width="36px" height="36px" className="pn-icon" viewBox="0 0 24 24">
                        <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
                      </svg>
                    </Col>
                  </button>
                  }
                </Row>
              </Col>
            </Row>
            }

          </Col>
          <Col xs={3} className={`info-view ${!this.state.showInfo ? 'hidden' : ''}`}>
            {Object.keys(details).length > 0  && Object.keys(this.props.project) &&
            <Row>
              <Col xs={12}>
                <Row middle="xs" className="info-view-header">
                  <Col xs={10}>
                    <h2>Info</h2>
                  </Col>
                  <Col xs={2}>
                    <button onClick={this.handleShowInfoClick} className="close-info">
                      <svg width="24px" height="24px" viewBox="0 0 24 24">
                        <path d="M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z" />
                      </svg>
                    </button>
                  </Col>
                </Row>
                <Row start="xs">
                  <Col xs={12}>
                    <h3>Project</h3>
                  </Col>
                </Row>
                <Row className="info-view-project">
                  <Col xs={3}>
                    {projectImage}
                  </Col>
                  <Col xs={9}>
                    {this.props.project.title}<br />
                    {this.props.project.address}<br />
                  </Col>
                </Row>
                {this.renderFileDetails()}
                {this.renderLinkedIssues()}
                {this.renderStaticMap()}
              </Col>
            </Row>
            }
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FileDetailsScreen);
